<template>
  <div class="panels-container">
    <div class="panel left-panel">
      <img src="/img/logo-school.svg" class="image" alt="Logo school" />
      <img
        src="/img/auth/register.svg"
        class="image hidden lg:block"
        alt="Register image"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DescPanel"
};
</script>

<style lang="scss" scoped>
.isis-container {
  .panels-container {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    @media screen and (max-width: 870px) {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 2fr 1fr;
    }

    .panel {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-around;
      text-align: center;
      z-index: 6;

      &.left-panel {
        pointer-events: all;
        padding: 3rem 17% 2rem 12%;
      }

      .content {
        color: #fff;
        transition: transform 0.9s ease-in-out;
        transition-delay: 0.6s;
      }

      h3.content__brand {
        font-weight: 600;
        line-height: 1;
        font-size: 1.5rem;
        letter-spacing: 0.2rem;
      }

      p {
        font-size: 0.95rem;
        padding: 0.7rem 0;
      }

      .image {
        width: 100%;
        transition: transform 1.1s ease-in-out;
        transition-delay: 0.4s;
      }

      @media screen and (max-width: 870px) {
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        padding: 2.5rem 8%;
        grid-column: 1 / 2;

        &.left-panel {
          grid-row: 1 / 2;
        }

        .image {
          width: 200px;
          transition: transform 0.9s ease-in-out;
          transition-delay: 0.6s;
        }

        .content {
          padding-right: 15%;
          transition: transform 0.9s ease-in-out;
          transition-delay: 0.8s;
        }

        h3 {
          font-size: 1.2rem;
        }

        p {
          font-size: 0.7rem;
          padding: 0.5rem 0;
        }
      }

      @media screen and (max-width: 570px) {
        .content {
          padding: 0.5rem 1rem;
        }
      }
    }
  }
}
</style>
